"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var currency_1 = require("../../../../../formatters/currency");
var padding_1 = require("../../../../padding");
var text_1 = require("../../../../text");
var input_1 = (0, tslib_1.__importDefault)(require("../../shared/input"));
var table_1 = require("../../shared/table");
function EditableCell(props) {
    var testId = props.testId, onChange = props.onChange, value = props.value, isEditable = props.isEditable;
    var _a = (0, react_1.useState)(false), isEditing = _a[0], setEditing = _a[1];
    return (react_1.default.createElement(table_1.StyledCell, { disabled: !isEditable }, isEditing ? (react_1.default.createElement(input_1.default, { isEditable: isEditable, testId: testId, placeholder: "0", onChange: onChange, onBlur: function () { return setEditing(false); }, value: value, className: (0, currency_1.isNegative)(value) ? 'negative' : '' })) : (react_1.default.createElement(table_1.StyledToggleCell, { className: (0, currency_1.isNegative)(value) ? 'negative' : '', onClick: function () {
            if (isEditable) {
                setEditing(true);
            }
        }, "data-testid": "".concat(testId, "-editable") },
        react_1.default.createElement(padding_1.Padding, { size: 12 },
            react_1.default.createElement(text_1.Text, { color: "dark", size: "small" },
                react_1.default.createElement("span", { "data-testid": "".concat(testId, "-static") }, (0, currency_1.currencyFormat)(value))))))));
}
exports.default = EditableCell;
//# sourceMappingURL=editable-cell.js.map